import React from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

export interface SidebarSection {
  id: string;
  label: string;
}

interface GuideSidebarProps {
  sections: SidebarSection[];
  activeSection: string;
  onSectionClick: (sectionId: string) => void;
}

const GuideSidebar: React.FC<GuideSidebarProps> = ({
  sections,
  activeSection,
  onSectionClick,
}) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 100,
        width: 240,
        flexShrink: 0,
        display: { xs: 'none', md: 'block' },
      }}
    >
      <Typography
        variant="overline"
        sx={{
          color: 'text.secondary',
          fontWeight: 600,
          px: 2,
          mb: 1,
          display: 'block',
        }}
      >
        On This Page
      </Typography>
      <List dense disablePadding>
        {sections.map((section) => (
          <ListItemButton
            key={section.id}
            selected={activeSection === section.id}
            onClick={() => onSectionClick(section.id)}
            sx={{
              borderRadius: 1,
              mx: 1,
              py: 0.75,
              '&.Mui-selected': {
                bgcolor: 'primary.50',
                color: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.100',
                },
              },
            }}
          >
            <ListItemText
              primary={section.label}
              primaryTypographyProps={{
                variant: 'body2',
                fontWeight: activeSection === section.id ? 600 : 400,
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default GuideSidebar;
